import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useCurrentUserRole } from '@/hooks/use-current-user-role';

const DashboardRedirectPage = () => {
  const role = useCurrentUserRole();

  if (role === undefined) {
    return null;
  }

  if (role === 'provider') {
    return <Navigate to='/provider/dashboard' search={{ draftId: undefined }} />;
  }
  if (role === 'operator' || role === 'admin') {
    return <Navigate to='/operators/dashboard' />;
  }

  return <Navigate to='/substitute/dashboard' />;
};

export const Route = createFileRoute('/_protected/dashboard')({
  loader: async () => {
    const { default: i18n } = await import('../i18n');
    await i18n.loadNamespaces?.(['dashboard', 'common']);
    return null;
  },
  component: DashboardRedirectPage,
});
